export default "__VITE_ASSET__CsdNBp5k__"